<template>
  <f7-page>
    <navbar :text="`${$t('Plans.title')} > ${$t('Plans.details')}`" />
    <ModalCopyReferencePlan
      :id="currentPlanId"
      :visible="ShowModal"
      type="nutrition"
      @close="ShowModal = false"
      @copy="copy"
    />
    <template v-if="currentTypePlan === 'fertilization'">
      <NutritionDetailComponent
        v-if="loaded"
        :fertilization="currentPlan"
        :plantation-property="actualPlantation"
        :hide-report-button="false"
        :called-from-view-plan="true"
        @open-copy-modal="ShowModal = true"
      />
      <f7-row no-gap>
        <f7-col style="align-self: stretch">
          <ElementResumeComponent
            v-if="loaded"
            class="element-resume"
            :fertilization="currentPlan"
          />
        </f7-col>
        <f7-col>
          <ProductResumeChartComponent
            v-if="loaded"
            :fertilization="currentPlan"
          />
        </f7-col>
      </f7-row>
      <ProductResumeComponent
        v-if="loaded"
        :plantationData="actualPlantation"
        :fertilization="currentPlan"
      />

      <ProductResumeTable
        v-if="loaded"
        :fertilization="currentPlan"
      />

      <IrrigationResumeTable
        v-if="loaded && !showIrrigationTable && showOldIrrigationTable"
        :fertilization="currentPlan"
      />

      <ApplicationEfficiencyPerPeriod
        v-if="isNew && loaded"
        :fertilization="currentPlan"
      />

      <div v-if="loaded" class="content-devx margin-half" style="padding: 0">
        <div style="padding: 4px">
          <div class="main-title-content" style="padding: 9px">
            CALENDARIO DE RIEGO Y FERTIRRIGACIÓN
          </div>
          <div>
            <div v-if="currentPlan.period == 'DIARIO'" class="card-body main">
              <section id="irrgation-calendar-section" class="irrigation-calendars">
                <div id="calendar-irrigation-section" class="irrigation-calendars__item">
                  <CalendarViewer
                    :startDate="currentPlan.init_date"
                    :endDate="currentPlan.end_date"
                    :customDatesOne="irrigationDates"
                    :customDatesTwo="fertirrigationDates"
                  />
                </div>
                <div class="irrigation-calendars__item">
                  <div class="calendar-legend">
                    <span class="calendar-legend__item">
                      <span class="calendar-legend__color calendar-legend__color--irrigation"></span>
                      Días con riego
                    </span>
                    <span class="calendar-legend__item">
                      <span class="calendar-legend__color calendar-legend__color--fertilization"></span>
                      Días con fertilización
                    </span>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <PaoResume v-if="loaded" :fertilization="currentPlan" />

      <Observations v-if="loaded" :fertilization="currentPlan" />
    </template>
    <template v-else>
      <TreatmentDetailPlanComponent
        v-if="loaded"
        :id="currentPlanId"
        :hide-back-button="true"
        :called-from-view-plan="true"
        :hide-report-button="false"
      />
    </template>
    <div class="content-navigation">
      <f7-button
        class="dx-btn-cancel padding-left padding-right margin-bottom"
        type="default"
        text-color="gray"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToBack()"
      >
        {{ $t("Button_go_to_back") }}
      </f7-button>
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";
import navbar from "../../../components/NavBar.vue";
import NutritionDetailComponent from "../../../components/nutritionDetail/nutritionDetail/index.vue";
import ElementResumeComponent from "../../../components/nutritionDetail/elementResume/index.vue";
import ProductResumeComponent from "../../../components/productResume/ProductResume.vue";
import ProductResumeTable from "../../../components/nutritionDetail/productResumeTable/index.vue";
import IrrigationResumeTable from "../../../components/nutritionDetail/irrigationResumeTable/index.vue";
import TreatmentDetailPlanComponent from "../../../components/wizardTreatment/treatmentDetailPlan/index.vue";
import Observations from "../../../components/nutritionDetail/observations/index.vue";
import ProductResumeChartComponent from "../../../components/nutritionDetail/productResumeChart/index.vue";
import ApplicationEfficiencyPerPeriod from "../../../components/nutritionDetail/ApplicationEfficiencyPerPeriod/index.vue";
import PaoResume from "../../../components/nutritionDetail/paoResume/index.vue";
import CalendarViewer from "../../../components/CalendarViewer/CalendarViewer.vue";
import ModalCopyReferencePlan from "../../../components/utilities/referencePlans/detail/ModalCopyReferencePlan.vue";
import Api from "../../../services/Api";
import fertilizationService from "../../../services/fertilizationService";

export default {
  name: "ViewPlanDetail",
  components: {
    navbar,
    NutritionDetailComponent,
    ElementResumeComponent,
    ProductResumeComponent,
    ProductResumeTable,
    IrrigationResumeTable,
    TreatmentDetailPlanComponent,
    Observations,
    ProductResumeChartComponent,
    ApplicationEfficiencyPerPeriod,
    PaoResume,
    CalendarViewer,
    ModalCopyReferencePlan,
  },
  data() {
    return {
      loaded: false,
      ShowModal: false,
      showOldIrrigationTable: false,
      irrigationDates: [],
      fertirrigationDates: [],
    };
  },
  computed: {
    showIrrigationTable() {
      return (
        (this.currentPlan?.periods_irrigation &&
          this.currentPlan.periods_irrigation.every((value) => value === 0)) ??
        true
      );
    },
    ...mapState("Plans", ["currentPlanId", "currentTypePlan", "currentPlan"]),
    ...mapState("RegisterPlantation", ["actualPlantation"]),
    ...mapState("Plantation", ["plantations"]),
    ...mapState("nutritionStepper", ["isNew"]),
    ...mapGetters("nutritionStepper", ["nutritionIrrigationData"]),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.getPlanById({
        planId: this.currentPlanId,
        typePlan: this.currentTypePlan,
      });
      const newPlan = this.currentPlan?.version === "2.2.0";
      this.setIsNew(newPlan);

      const data = {
        companyId: this.currentPlan.company_id,
        plantationId: this.currentPlan.plantation,
      };
      this.showOldIrrigationTable = this.currentPlan.old_irrigation_table;

      await this.getPlantationById(data);

      if (this.currentTypePlan === "fertilization") {
        await fertilizationService
          .getById(this.currentPlanId, this.currentPlan.company_id, true)
          .then((response) => {
            this.setStepNutritionIrrigationData(response);
          });
        this.getIrrigationDatesFromNutritionData();
      }

      this.setActualUser({ id: this.currentPlan.company_id });

      this.formatPlantation(this.actualPlantation);
      if (this.currentTypePlan === "fertilization") {
        this.$fa.logEvent(
          "analisis_planes_nutricion",
          {
            id: this.actualPlantation.id,
            content_type: "view",
            description:
              "Evento al entrar a Analisis/planes seleccionando un plan de nutricion",
          },
          this.actualPlantation
        );
      } else {
        this.$fa.logEvent(
          "analisis_planes_tratamiento",
          {
            id: this.actualPlantation.id,
            content_type: "view",
            description:
              "Evento al entrar a Analisis/planes seleccionando un plan de tratamiento",
          },
          this.actualPlantation
        );
      }
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(`${error}`),
          width: 550,
        },
        "error",
        3000
      );
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    async copy(date) {
      this.$f7.preloader.show();
      try {
        const planDuration =
          moment(this.currentPlan.end_date).diff(
            moment(this.currentPlan.init_date),
            "days"
          ) || 0;

        const xhr = await Api.getPlantationById(
          this.currentPlan.company_id,
          this.currentPlan.plantation
        );
        const plantation = JSON.parse(xhr.response);
        this.$f7.preloader.hide();

        this.$f7router.navigate({
          name: "nutrition-plans-copy",
          params: {
            id: this.currentPlanId,
          },
          query: {
            date,
            duration: planDuration,
            species: plantation.species,
          },
        });
      } catch (error) {
        this.$f7.preloader.hide();
        this.$notifyDX(
          {
            message: this.$t(`${error}`),
            width: 550,
          },
          "error",
          3000
        );
      }
    },
    goToBack() {
      this.$f7.views.main.router.navigate("/plans/", { reloadCurrent: true });
    },
    formatPlantation(plantation) {
      const currentPlant = {
        id: plantation.id,
        companyId: this.currentPlan.company_id,
        company: plantation.company_name,
        name: plantation.name,
        province: plantation.province,
        explotation: plantation.explotation,
        parcel: plantation.parcel,
        sector: plantation.sector_name,
        campaign: plantation.campaign,
        variety: plantation.variety,
        initDate: plantation.init_date,
        endDate: plantation.end_date,
        species: plantation.species,
        status: plantation.status,
        area: this.currentPlan.area,
        coordinates: plantation.coordinates,
        sectorId: plantation.sectorId,
        sectorIdLeftComparator: false,
        sectorIdRightComparator: false,
        isPlantationSelected: false,
      };

      this.setCurrentPlantation(currentPlant);
    },
    getStatusCampaign(initDate, endDate) {
      if (moment(this.actualDate).isBetween(initDate, endDate)) {
        return this.$t("status_campania_active");
      }
      if (endDate < this.actualDate) {
        return this.$t("status_campania_end");
      }
      return this.$t("status_campania_pending");
    },
    getIrrigationDatesFromNutritionData() {
      this.irrigationDates = [];
      this.fertirrigationDates = [];

      if (
        this.nutritionIrrigationData &&
        Array.isArray(this.nutritionIrrigationData.data)
      ) {
        this.nutritionIrrigationData.data.forEach((yearObj) => {
          yearObj.items.forEach((monthObj) => {
            Object.entries(monthObj.dates).forEach(([date, info]) => {
              const [day, month, year] = date.split("/");
              const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

              const hasDoseOrTotal =
                Array.isArray(info.products) &&
                info.products.some(
                  (prod) =>
                    (prod.dosis !== null &&
                      prod.dosis !== undefined &&
                      !isNaN(prod.dosis) &&
                      Number(prod.dosis) > 0) ||
                    (prod.totales !== null &&
                      prod.totales !== undefined &&
                      !isNaN(prod.totales) &&
                      Number(prod.totales) > 0)
                );

              if (info.irrigation_time && !hasDoseOrTotal) {
                this.irrigationDates.push(formattedDate);
              }
              if (hasDoseOrTotal) {
                this.fertirrigationDates.push(formattedDate);
              }
            });
          });
        });
      }
    },
    ...mapActions("Plans", ["getPlanById"]),
    ...mapActions("RegisterPlantation", ["getPlantationById"]),
    ...mapActions("Plantation", ["setCurrentPlantation"]),
    ...mapActions("fertilizationStore", ["setCurrentFertilizationId"]),
    ...mapActions("Explotaciones", ["setActualUser"]),
    ...mapActions("nutritionStepper", ["setIsNew", "setStepNutritionIrrigationData"]),
  },
};
</script>

<style scoped>
.dx-btn-cancel {
  width: fit-content;
}
.element-resume {
  display: flex;
  height: 100%;
}
</style>
